import { render, staticRenderFns } from "./KernelSettings.vue?vue&type=template&id=9e044fbe&"
import script from "./KernelSettings.vue?vue&type=script&lang=js&"
export * from "./KernelSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports